export const GetShareSettingsApi = Symbol('GetShareSettingsApi');
